import { NgxSeo } from "./modules/ngx-seo/ngx-seo";

const SITE_NAME = ' - MarkoutPro.com'
const BASIC_KEYWORDS = ', markout management, utility locating, damage prevention'

export class  SEOData {
    
    public static DEFAULT_TITLE = "Markout Tracking Software" + SITE_NAME
    

    public static LOGIN: NgxSeo = {
      title: 'Login - Log in to your account' + SITE_NAME,
      meta: {
        description: 'Log in to your account at MarkoutPro.com to manage your utility markouts.',
        keywords: 'login, account, sign in, support' + BASIC_KEYWORDS
      },
    };

    public static REGISTER: NgxSeo = {
      title: 'Register - Create a new account' + SITE_NAME,
      meta: {
        description: 'Register in 28 seconds and take your projects to the next level.',
        keywords: 'register, registration, new account' + BASIC_KEYWORDS
      },
    };
   
    public static FORGOT_PASSWORD: NgxSeo = {
      title: 'Password Reset - Forgot your password?' + SITE_NAME,
      meta: {
        description: 'Lost access to your account? Regain access using your email address.',
        keywords: 'password reset, account recovery, forgot password' + BASIC_KEYWORDS
      },
    };

}